import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Paper,
  Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqData = [
  {
    question: "Who can become a Global Partner?",
    answer: `
      Applicants must meet the following criteria: 
      <br/><br/>
      <b>Citizen of the Country:</b> The applicant must be a legal citizen of the respective country, ensuring a thorough understanding of the local culture, business dynamics, and regulatory framework. 
      <br/><br/>
      <b>Established Business in the Country:</b> A legally registered and operational business in the country is required to demonstrate credibility, stability, and an established presence in the market. 
      <br/><br/>
      <b>Preference for Agri-Business Experience:</b> Applicants with a background in agriculture-related businesses are given preference, as they bring valuable industry insights and are better positioned to address sector-specific needs. 
      <br/><br/>
      <b>Allied Services to Agriculture are also welcome:</b> Businesses involved in allied sectors like agri-tech, logistics, machinery, or support services that complement agriculture are encouraged, as they enhance the ecosystem's overall efficiency.
    `
  },
  {
    question: "What is the role & responsibility of a Global Partner?",
    answer: `
      Every Buyer is assigned a Global Partner who will maintain a trade relationship with the buyer. 
      Our Global Partners have complete control over the margin of the deals in their jurisdiction 
      to ensure the price always matches the buyer’s expectations. 
      <br/><br/>
      The Global Partner plays the customer-facing role of Client Relationship Partner for the trade. 
      We do not interact directly with the buyer — we let you handle the relationship here!
    `
  },
  {
    question: "What is the Pricing Control Policy for Global Partners?",
    answer: `
      You control the pricing to perfectly match your client’s needs and market. 
      With your insights, you’re the best judge of the right price. 
      <br/><br/>
      With complete transparency, you can unlock hidden profits, 
      creating lasting, successful, and fulfilling partnerships.
    `
  },
  {
    question: "Is there a financial commitment to join as a Global Partner?",
    answer: `
      There is no mandatory financial commitment. However, partners are encouraged to contribute 
      through expertise, network access, or voluntary funding to scale the initiative’s impact.
    `
  },
  {
    question: "What is the selection process for Global Partners?",
    answer: `
      Each application is reviewed based on:
      <ul class="pt-4">
        <li>Alignment with AMTPL’s mission.</li>
        <li>Proven track record in supporting agricultural entrepreneurship.</li>
        <li>Potential contribution to the program’s growth.</li>
        <li>Business credibility and reputation.</li>
      </ul>
    `
  }
];


const BuyerFaq = () => {
  return (
    <div className="container" style={{fontSize:"14x !important"}}>
      <div className="faq-content">
        

        <Box className="container p-2">
          <Paper elevation={1} sx={{ p: 2 }}>
            <div
          className="table-header"
          style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}
        >
          <div className="header-text">
            <div className="head-text">Frequently Asked Questions</div>
          </div>
        </div>

            {faqData.map((faq, index) => (
              <Accordion key={index} sx={{ border: '1px solid #e0e0e0', borderRadius: '6px', mb: 1 }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`faq-content-${index}`}
                  id={`faq-header-${index}`}
                  sx={{
                    backgroundColor: index % 2 === 0 ? '#f5f7fa' : '#e8edf3',fontSize:"14px !important",
                    fontWeight: 600
                  }}
                >
                  <Typography fontWeight={600}>{faq.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ fontSize: '14px' }}
                  >
                   <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Paper>
        </Box>
      </div>
    </div>
  );
};

export default BuyerFaq;
